import { render, staticRenderFns } from "./coreData.vue?vue&type=template&id=61f7cfaa&scoped=true&"
import script from "./coreData.vue?vue&type=script&lang=js&"
export * from "./coreData.vue?vue&type=script&lang=js&"
import style0 from "./coreData.vue?vue&type=style&index=0&id=61f7cfaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f7cfaa",
  null
  
)

export default component.exports